import React, { useEffect } from 'react';

/** Fallback if something still mounts this page — open create-deal modal via navigate. */
export function DealNew({ onNavigate }) {
  useEffect(() => {
    onNavigate?.('dm-new-deal');
  }, [onNavigate]);

  return (
    <div className="page-state">
      <p>Opening new deal…</p>
    </div>
  );
}

export default DealNew;
